/** Domaine canonique unique — ne pas mélanger avec d'autres URLs. */
export const SITE_ORIGIN = 'https://lbenna-prod.com';
export const SITE_NAME = 'Lbenna Prod';
export const SITE_OG_NAME = 'Lbenna Production';
export const DEFAULT_OG_IMAGE = `${SITE_ORIGIN}/og-image.jpg`;
export const SITE_LOGO = `${SITE_ORIGIN}/logo.png`;
export const DEFAULT_LOCALE = 'fr_TN';
